module["exports"] = [
  "gmail.com",
  "yahoo.fr",
  "hotmail.fr"
];
